export enum MemberStatusType {
  active = 1,
  inactive = 2,
  suspended = 3,
  deceased = 4,
  expelled = 5,
  leaveOfAbsence = 6,
  resigned = 7,
  terminated = 8,
  other = 9,
}
